module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/equipment03-bb2d37acc7a4c1dc5622e7fb2d621184.png";